<template>
  <div class="box">
    <div class="flex">
      <div class="topboxcon" v-for="item in cardList" v-on:click="defultUserCard(item.PatID)">
        <div class="cardinfo clearfix">
          <div class="codeinfo clearfix">
            <p>{{item.Name}}&nbsp;&nbsp;&nbsp;{{item.Sex}}</p>
            <P>{{item.PatNo}}&nbsp;&nbsp;&nbsp;{{item.CardNumber}}</P>
          </div>
        </div>
        <div class="cut" @click.stop>
          <div class="defult">
            <input
              type="radio"
              class="ipt"
              name="one"
              :checked="item.Default"
              v-on:click="defultUserCard(item.PatID)"
            >
            <span>{{item.Default | defaultFilters}}</span>
          </div>
          <div class="del">
            <img src="../../assets/images/del.png" class="radio" alt>
            <!-- <span @click="unbind">解绑</span> -->
            <span v-on:click.stop="untying(item.PatID)">解绑</span>
          </div>
        </div>
      </div>
      <div class="fontcss">已添加{{cardListCount}}位家庭人员，还可以添加{{5-cardListCount}}位</div>
    </div>
    <div class="addbnt" @click="addcard">
      <img src="../../assets/images/addicon.png" alt class="addicon">
      <span>添加就诊卡</span>
    </div>
    <!-- 遮罩弹窗 -->
    <div class="popContainer" v-show="isshow">
      <div class="popcon">
        <div class="topbig">操作确认</div>
        <div class="popdeteil">
          <p>解绑后不能再查到之前的相关就诊记录，请谨慎操作</p>
        </div>
        <div class="btnbox">
          <span @click="unbundle">解除绑定</span>
          <span @click="cancelbundel">取消</span>
        </div>
      </div>
    </div>

    <div class="popContainer" v-show="isshowt">
      <div class="popcon">
        <div class="topbig">操作确认</div>
        <div class="popdeteil">
          <p style="text-align: center;">你确定要解绑吗？</p>
        </div>
        <div class="btnbox">
          <span @click="untyingSure">确定</span>
          <span @click="canceuntyingSure">取消</span>
        </div>
      </div>
    </div>
    <!-- 结束 -->
  </div>
</template>

<script>
import {
  GetAllCardByOpenID,
  UntyingUserCard,
  DefultUserCard,
  SetItem
} from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "swith-card",
  data() {
    return {
      isshowt:false,
      isshow: false,
      false:false,
      active: true,
      cardList: [],
      cardListCount: 0,
      $dialog: [],
      cardNumber:'',
      patID:''
    };
  },
  created: function() {
    this.getAllCardByOpenID();
  },
  destroyed: function() {
    if (Object.prototype.toString.call(this.$dialog) !== "[object Function]") {
      this.$dialog.hide();
    }
  },
  methods: {
    unbind() {
      this.isshow = true;
       this.isshowt=false;
    },
    unbundle() {
      this.isshow = false;
    },
    cancelbundel() {
      this.isshow = false;
    },

    collect() {
      this.active = !this.active;
    },
    addcard() {
      //跳转到添加就诊卡页
      this.$router.push({ path: "/card/addcard", query: { active: false ,PatInfos:JSON.stringify(this.cardList) }});
    },
    untying(patID) {
      this.isshowt=true;
      this.isshow = false;
      this.patID=patID;
      
    },
    untyingSure(){
      this.isshowt=false;
      console.log(this.patID);

      UntyingUserCard(this.patID).then(response => {
        if (response.data.Result) {
          this.getAllCardByOpenID();
        } else {
          this.$dialog = weui.dialog({
            title: "提示",
            content: response.data.Content
          });
        }
      });
    },
    canceuntyingSure(){
       this.isshowt=false;
    },
    setDefault() {},
    defultUserCard(patID) {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "设置中"
      });
      DefultUserCard(patID).then(response => {
        var _that = this;
        loading.hide();
        if (response.data.Result) {
          SetItem("patid", response.data.Extend);
          this.$dialog = weui.dialog({
            title: "提示",
            content: "设置成功！",
            buttons: [
              {
                label: "确定",
                type: "primary",
                onClick: function() {
                  _that.$router.back(-1);
                }
              }
            ]
          });
          this.getAllCardByOpenID();
        } else {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "设置失败！"
          });
        }
      });
    },
    getAllCardByOpenID() {
      var _that = this;
      GetAllCardByOpenID().then(response => {
        if (response.data) {
          this.cardList = response.data;
          this.cardListCount = response.data.length;
          response.data.forEach(function(item) {
            if (item.Default) {
              _that.$store.commit("setUserInfo", item);
              SetItem("patid", item.PatID);
            }
          });
        }
      });
    }
  },
  filters: {
    defaultFilters: function(value) {
      if (value) {
        return "当前默认";
      } else {
        return "设为默认";
      }
    }
  }
};
</script>
<style>
#app {
  height: 100%;
}

.box {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.box .codebox {
  float: left;
}

.box .flex {
  flex: 1;
}

.topboxcon {
  flex: 1;
  margin: 0.2rem;
  border: 0.4rem;
  border-color: #dddddd;
  border-radius: 0.1875rem;
  box-shadow: 0.1875rem, 0.1875rem, 0.625rem, #c8d6df;
  height: 2.4rem;
  text-align: center;
  background-color: white;
  color: #3d97d1;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  position: relative;
  margin-bottom: 0 !important;
}

.card {
  margin: 0.625rem;
  border: 0.0625rem;
  border: 0.4rem;
  border-color: #dddddd;
  border-radius: 0.1875rem;
  box-shadow: 0.1875rem, 0.1875rem, 0.625rem, #c8d6df;
  width: 18.75rem;
  height: 7.5rem;
  background-color: white;
  font-family: "MicrosoftYaHei";
  position: relative;
}

.cardinfo {
  padding-left: 0.38rem;
  padding-bottom: 0.28rem;
  border-bottom: 0.01rem dotted #dcdcdc;
  position: relative;
}

.triangle {
  position: absolute;
  right: 0;
  width: 0;
  height: 0rem;
  border-radius: 0 0.1875rem 0 0;
  border-width: 0.37rem 0.5rem;
  border-style: solid;
  border-color: #fda62b #fda62b transparent transparent;
  font-size: 0.18rem;
  color: #fefefe;
}

.triangle .triantext {
  position: absolute;
  top: -0.22rem;
  left: -0.01rem;
  white-space: nowrap;
  font-size: 0.18rem;
  transform: rotate(37deg);
}

.topboxcon .twocode {
  display: inline-block;
  width: 0.66rem;
  height: 0.66rem;
  /* margin-left: 0.38rem; */
  margin-top: 0.53rem;
  margin-right: 0.29rem;
}

.codeinfo {
  float: left;
}

.codeinfo > p:first-child {
  color: #333333;
  font-size: 0.3rem;
  text-align: left !important;
  margin-top: 0.42rem;
}

.codeinfo > p:last-child {
  color: #999999;
  font-size: 0.3rem;
  text-align: left !important;
}

.cut {
  box-sizing: border-box;
  padding-top: 0.2rem;
}

.defult {
  float: left;
  margin-left: 0.23rem;
}

.radio {
  width: 0.28rem;
  height: 0.28rem;
  display: inline-block;
  vertical-align: text-bottom;
}

.del {
  float: right;
  margin-right: 0.25rem;
}

.box .fontcss {
  font-size: 0.22rem;
  color: #999999;
  text-align: center;
  /* margin-bottom: 2.68rem; */
  margin-top: 0.3rem;
}

.addbnt {
  /* flex: 1; */
  background-color: #1592e4;
  height: 0.8rem;
  margin: 0.2rem;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  color: #fffefe;
  text-align: center;
  line-height: 0.8rem;
}

.cut .defult .ipt {
  float: left;
  top: 0.05rem;
  right: 0.1re;
  margin-right: 0.1rem;
}

.addicon {
  width: 0.28rem;
  height: 0.28rem;
  display: inline-block;
  vertical-align: text-bottom;
  border: 0.02rem solid white;
  border-radius: 50%;
}
.cut .defult > input[type="radio"]:checked {
  /* content: "✓"; */
  /* content: ""; */
  display: inline-block;
  position: relative;
  color: #fff;
  font-weight: 400;
  z-index: 1;
  background-color: #1592e4;
  padding-left: -0.15rem;
  border-radius: 50%;
  padding-left: 0.05rem;
  box-sizing: border-box;
  width: 0.28rem;
  height: 0.28rem;
  background-image: url("../../assets/images/check.png");
  background-position: center center;
}
/* 遮罩弹窗样式 */
div.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
}

.popContainer .popcon {
  width: 4.19rem;
  height: 3rem;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -2.08rem;
  margin-top: -1.5rem;
}

.popContainer .popcon .topbig {
  width: 100%;
  height: 0.8rem;
  background-color: #1592e4;
  line-height: 0.8rem;
  text-align: center;
  color: white;
  font-size: 0.26rem;
}

.popContainer .popcon .popdeteil {
  font-size: 0.24rem;
  color: #333333;
  border-bottom: 0.01rem solid #dcdcdc;
  font-family: "MicrosoftYaHei";
  box-sizing: border-box;
  padding: 0.4rem 0.2rem;
}

.popContainer .btnbox {
  display: flex;
  flex-direction: row;
  text-align: center;
  line-height: 0.7rem;
}

.popContainer .btnbox > span {
  flex: 1;
  color: #1592e4;
  font-size: 0.26rem;
}

/* 遮罩弹窗样式 结束*/
</style>



// WEBPACK FOOTER //
// src/components/addcard/switch-card.vue